export const TableHeader = ({ table }) => (
  <thead>
    {table.getHeaderGroups().map((headerGroup) => (
      <tr key={headerGroup.id}>
        {headerGroup.headers.map((header) => (
          <th key={header.id} colSpan={header.colSpan}>
            {header.isPlaceholder ? null : (
              <div
                {...{
                  className: header.column.getCanSort()
                    ? 'cursor-pointer select-none flex items-center gap-1'
                    : '',
                  onClick: header.column.getToggleSortingHandler(),
                }}
              >
                {header.column.columnDef.header}
                {{
                  asc: '▲',
                  desc: '▼',
                }[header.column.getIsSorted()] ?? null}
              </div>
            )}
          </th>
        ))}
      </tr>
    ))}
  </thead>
);
